import { FlexBox } from 'src/ui/common/atoms/flex-box';
import styled from 'styled-components';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';

export const StyledRowItem = styled(FlexBox)`
  color: white;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;

  & + & {
    margin-top: 10px;
  }
`;

export const StyledEllipsedText = styled(Typography)`
  flex: 1;
  cursor: pointer;
  text-align: right;
  max-width: 40vw !important;
  margin-right: 5px;
  
  ${media.sm`
    max-width: 200px !important;
  `}
`;

export const StyledLink = styled.a`
  white-space: nowrap;
  max-width: 45vw; 
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  
  ${media.sm`
    max-width: 30vw;
  `}

  ${media.md`
    max-width: 25vw;
  `}
  
  ${media.lg`
    max-width: 320px;
  `}
`;
